import operatorApiFetch from './apiService';

const flexibleProductService = {
  // 獲取彈性置換商品列表（用於表格）
  getRecords: async (params = {}) => {
    const res = await operatorApiFetch('flexible_products/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取所有彈性置換商品 ID（用於篩選）
  getIds: async (params = {}) => {
    const res = await operatorApiFetch('flexible_products/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取單個彈性置換商品
  get: async (id) => {
    const res = await operatorApiFetch(`flexible_products/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 創建彈性置換商品
  create: async (data) => {
    const res = await operatorApiFetch('flexible_products', {
      method: 'POST',
      body: { flexible_product: data }
    });
    return res.json();
  },

  // 更新彈性置換商品
  update: async (id, data) => {
    const res = await operatorApiFetch(`flexible_products/${id}`, {
      method: 'PUT',
      body: { flexible_product: data }
    });
    return res.json();
  },

  // 刪除彈性置換商品
  delete: async (id) => {
    const res = await operatorApiFetch(`flexible_products/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  }
};

export { flexibleProductService };
export default flexibleProductService;
